export enum LiveClassDurationTypes {
    MINUTES_30 = "minutes_30",
    HOURS_1_MINUTES_0 = "hour_1_minutes_0",
    HOURS_1_MINUTES_30 = "hour_1_minutes_30",
    HOURS_2_MINUTES_0 = "hour_2_minutes_0",
    HOURS_2_MINUTES_30 = "hour_2_minutes_30",
    HOURS_3_MINUTES_0 = "hour_3_minutes_0"
}